import apiClient from "../../../utilities/apiClient";
import { ROLES, ADMIN_ROLES } from "../../../utilities/roles";

import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";
import { getFeatureFlag } from "../../../common/featureFlags/FeatureProvider";

export const get_lot_numbers = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const vendor_id = user.vendor_id;
  return apiClient.get(
    `${apiClient.Urls.lot_accept_numbers}?vendor_id=${vendor_id}`,
    payload,
    true
  );
};

export const asns = (payload) => {
  const useAsnDetail = getFeatureFlag("asn_detail_includes");

  return useAsnDetail
    ? apiClient.post(`${apiClient.Urls.new_create_asns}`, payload, true, "file")
    : apiClient.post(`${apiClient.Urls.asns}`, payload, true, "file");
};

export const get_asns = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const useAsnDetail = getFeatureFlag("asn_detail_includes");

  const vendor_id = user.vendor_id;
  return apiClient.get(
    useAsnDetail
      ? `${apiClient.Urls.asns_list}?page=${payload?.page}&per_page=${payload?.per_page}&search=${payload?.search_key}`
      : `${apiClient.Urls.asns_list}?vendor_id=${vendor_id}`,
    "",
    true
  );
};

export const get_packaging_types = (payload) => {
  // var user = LocalStorage.getItem(SESSION_KEY);
  // const vendor_id = user.vendor_id;
  return apiClient.get(`${apiClient.Urls.packaging_type_info}`, payload, true);
};

export const view_UserAsnDetails = (payload) => {
  var role = LocalStorage.getItem(SESSION_KEY)?.roles;
  const useAsnDetail = getFeatureFlag("asn_detail_includes");

  return apiClient.get(
    useAsnDetail
      ? role[0] === ROLES.OFFICER
        ? `${apiClient.Urls.view_ans_details_for_officer}/${payload?.asn_id}?page=${payload?.page}&per_page=${payload?.per_page}`
        : `${apiClient.Urls.view_ans_details_for_vendor}/${payload?.asn_id}?page=${payload?.page}&per_page=${payload?.per_page}`
      : `${apiClient.Urls.view_user_asn_details}/${payload}`,
    "",
    true
  );
};

export const get_lot_items = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.get_lot_items}/?lot_id=${payload}`,
    payload,
    true
  );
};
export const asn_initial_data = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.asnInitialData}/${payload?.oid}?page=${payload?.page}&per_page=${payload?.per_page}`,
    "",
    true
  );
};
export const approve_reject_asn = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.asnApproveReject}/${payload?.asn_id}`,
    {
      is_accpet: payload?.is_accpet,
      reason: payload?.reason,
    },
    true
  );
};
export const view_ArnDetails = (payload) => {
  var role = LocalStorage.getItem(SESSION_KEY)?.roles;

  return apiClient.get(
    role[0] === ROLES.OFFICER
      ? `${apiClient.Urls.viewArnforOfficer}/${payload?.asn_id}?page=${payload?.page}&per_page=${payload?.per_page}`
      : `${apiClient.Urls.viewArnforVendor}/${payload?.asn_id}?page=${payload?.page}&per_page=${payload?.per_page}`,
    "",
    true
  );
};
